import { SelectChangeEvent } from '@mui/material';

const handleRemarks = (spec: any, obsIndex: number, cavityIndex: number) => {
  if (spec[`check_${obsIndex}_colors`][cavityIndex] === '#f7aeae') {
    spec[`check_${obsIndex}_results`][cavityIndex] = 'ng';
  }
  if (spec[`check_${obsIndex}_colors`][cavityIndex] === '#a4d1a4') {
    spec[`check_${obsIndex}_results`][cavityIndex] = 'ok';
  }

  if (spec[`check_${obsIndex}_colors`][cavityIndex] === '') {
    spec[`check_${obsIndex}_results`][cavityIndex] = '';
  }
};

const handleChangeSpec = (
  e: React.ChangeEvent<HTMLInputElement> | SelectChangeEvent<unknown>,
  spec: any,
  obsIndex: number,
  cavityIndex: number
) => {
  const value: any = e.target.value;

  spec[`check_${obsIndex}_values`][cavityIndex] = value;

  if (e.target.name === 'dropdown') {
    spec[`check_${obsIndex}_colors`][cavityIndex] =
      (value === 'ok' && '#a4d1a4') || (value === 'ng' && '#f7aeae') || '';
  }

  if (spec.appearance === 'check3') {
    return;
  }

  let mean = spec.mean;
  let utolerance = spec.utolerance || 0;
  let ltolerance = spec.ltolerance || 0;
  let old_utl = spec.utl;
  let old_ltl = spec.ltl;
  let check4_symbol = spec.check4_symbol;
  let checkbox4_num = spec.checkbox4_num;
  let utl;
  let ltl;
  let uv;
  let lv;

  //max
  if (check4_symbol && checkbox4_num) {
    if (check4_symbol === '<=') {
      if (value <= checkbox4_num) {
        spec[`check_${obsIndex}_colors`][cavityIndex] = '#a4d1a4';
      } else {
        spec[`check_${obsIndex}_colors`][cavityIndex] = '#f7aeae';
      }
    }
    //min
    if (check4_symbol === '>=') {
      if (value >= checkbox4_num) {
        spec[`check_${obsIndex}_colors`][cavityIndex] = '#a4d1a4';
      } else {
        spec[`check_${obsIndex}_colors`][cavityIndex] = '#f7aeae';
      }
    }
  } else {
    if (old_utl || old_ltl) {
      utl = parseFloat(old_utl);
      ltl = parseFloat(old_ltl);
      const mean = (utl + ltl) / 2;
      uv = (mean + utl) / 2;
      lv = (mean + ltl) / 2;
    } else {
      utl = parseFloat(mean) + parseFloat(utolerance);
      ltl = parseFloat(mean) - parseFloat(ltolerance);

      uv = parseFloat(mean) + parseFloat(utolerance) / 2;
      lv = parseFloat(mean) - parseFloat(ltolerance) / 2;
    }
    if (value > utl || value < ltl) {
      spec[`check_${obsIndex}_colors`][cavityIndex] = '#f7aeae';
    } else if ((uv < value && value <= utl) || (lv > value && value >= ltl)) {
      spec[`check_${obsIndex}_colors`][cavityIndex] = '#a4d1a4';
    } else if (value >= lv && value <= uv) {
      spec[`check_${obsIndex}_colors`][cavityIndex] = '#a4d1a4';
    }
  }

  if (value === '') {
    spec[`check_${obsIndex}_colors`][cavityIndex] = '';
  }
  handleRemarks(spec, obsIndex, cavityIndex);
};

export default handleChangeSpec;
